<template>
  <div>
    <div v-loading="loading">
      <div class="d-flex">
        <div class="pr-2">
          <el-image
            :src="defaultImageUrl"
            :preview-src-list="[defaultImageUrl]"
            style="width:150px; height:150px"
          >
            <div slot="error" class="image-slot">
              <img
                src="/image/static/img/nopic.jpg"
                style="width:150px; height:150px"
              />
            </div>
          </el-image>
        </div>
        <div style="flex:1">
          <div class="el-descriptions border-bottom-none">
            <div class="el-descriptions__body">
              <div
                class="el-descriptions__table is-bordered el-descriptions--small"
              >
                <div class="el-descriptions-row">
                  <div
                    class="el-descriptions-item__cell el-descriptions-item__label is-bordered-label"
                  >
                    <div class="sku_main">
                      <div>{{ formData.goodsName }}</div>
                      <div>{{ formData.goodsNameEn }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-descriptions border size="small" :column="2">
            <el-descriptions-item
              :label="$l('form_label_amzSkuNo') || 'SKU款号'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.amzSkuNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_ncNo') || 'NC编号'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.ncNo }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_brandName') || '品牌'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.brandName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_collectionName') || '系列'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.collectionName }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_goodsPattern') || '花型'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.goodsPattern }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_categoryFullName') || '品类'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
            >
              {{ formData.categoryFullName }}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions
            border
            size="small"
            :column="2"
            class="border-top-none"
          >
            <el-descriptions-item
              :label="$l('form_label_goodsSize') || '尺寸'"
              :labelStyle="{ width: '99px' }"
              :contentStyle="{ width: '492px' }"
            >
              {{ formData.goodsSize }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="$l('form_label_inCtnQty') || '入数'"
              :labelStyle="{ width: '99px' }"
              :contentStyle="{ width: '280px' }"
            >
              {{ formData.inCtnQty }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>

      <div class="side-frame-success">
        <span style="font-size: 14px; color: #606266">
          {{ $l('table_header_SkuInvOutofstockTable') || '断货信息' }}
        </span>
      </div>
      <SkuInvOutofstockTable :tableData="formData.invItems" />
    </div>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import { format, subtract, divide, roundDown } from '@/libs/util.number.js'
import SkuInvOutofstockTable from '../sku-inv-outofstock-table'
export default {
  components: { SkuInvOutofstockTable },
  mixins: [EditLoading],
  props: { amzListingSkuOutOfStockCode: { type: String, default: '' } },
  data() {
    return {
      formData: {},
      loading: false,
    }
  },
  computed: {
    submitQty() {
      return format(this.formData.submitQty)
    },
    unitInBox() {
      return format(this.formData.unitInBox)
    },
    invQty() {
      return format(this.formData.invQty)
    },
    ctnQty() {
      const { submitQty, unitInBox } = this.formData
      return format(roundDown(divide(submitQty, unitInBox), 1)) || '0'
    },
    shortageQty() {
      const { submitQty, invQty } = this.formData
      const shortageQty = subtract(submitQty, invQty)
      return format(shortageQty || 0)
    },
    defaultImageUrl() {
      const { defaultImageUrl } = this.formData
      return defaultImageUrl || '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzListingSkuOutOfStockCode) return
      this.loading = true
      const res = await this.$api
        .ecomAmzListingSkuOutofstockDetailApi({
          amzListingSkuOutOfStockCode: this.amzListingSkuOutOfStockCode,
        })
        .catch(() => null)
      this.loading = false
      this.formData = res?.body || {}
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .border-top-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
  .border-bottom-none {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-bottom: none !important;
    }
  }
}
.sku_main {
  font-size: 13px;
  font-weight: bold;
  color: #333;
}
</style>
